module.exports = __webpack_public_path__ + "static/3-a9465758d615abb25b0b478a0276650b.jpg";